import React from 'react';
import { NavLink } from 'react-router-dom';

import { Icon, Button } from '@safedns/skydns-ui-react-lib';
import sprite from '../../../icons/sprite.svg';

const ArrowButton = ({ url, title }) => {
  return (
    <div style={{ display: 'flex', alignItems: 'center', paddingBottom: 16 }}>
      <Button component={NavLink} href={url} sx={{ padding: 8, height: 20 }}>
        <Icon id="go-back" sprite={sprite} width={20} height={20} />
      </Button>

      <span style={{ fontSize: 14, fontWeight: 600, lineHeight: '20px' }}>
        {title}
      </span>
    </div>
  );
};

export default ArrowButton;
